import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import BottomSheet from '../../organisms/BottomSheet'
import useWindowSize from '../../../util/useWindowSize'
import { Tooltip } from '../Tooltip'

const Wrapper = styled.div``
const TextWrapper = styled.div``

const ResponsiveTooltip = ({ children, text, ...props }) => {
  const { isMobile } = useWindowSize()
  const [isOpen, setIsOpen] = useState(false)

  return isMobile ? (
    <>
      <Wrapper onClick={() => setIsOpen(true)}>{children}</Wrapper>
      <BottomSheet
        onLeftClick={() => setIsOpen(false)}
        onClose={() => setIsOpen(false)}
        open={isOpen}
        {...props}
      >
        {text}
      </BottomSheet>
    </>
  ) : (
    <Tooltip
      text={
        typeof text === 'string' ? (
          <span className="typo-body-small text-neutral-70">{text}</span>
        ) : (
          text
        )
      }
      {...props}
    >
      {children}
    </Tooltip>
  )
}

ResponsiveTooltip.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
}

export { ResponsiveTooltip }
